module.exports = __webpack_public_path__ + "img/cases_ams.c9f90872.jpg";